import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Navigation from './Navigation';
import Footer from './Footer';

function TimezoneSuccess() {
  const [userEmail, setUserEmail] = useState('');
  const [userTimezone, setUserTimezone] = useState('');
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const email = params.get('email');
    const timezone = params.get('timezone');

    if (email) {
      // Just use the raw email value - it's already properly encoded in the URL
      setUserEmail(email);
    }
    
    if (timezone) {
      setUserTimezone(decodeURIComponent(timezone));
    }
  }, [location]);

  return (
    <section className="theme-light section m-0 p-0" data-theme="light">
        <div className='fullHeight m-0 p-0 is-flex is-flex-direction-column is-justify-content-space-between'>
          <div>
            {/* Navigation */}
            <div className='columns is-flex is-flex-direction-rows is-justify-content-center'>
              <div className="m-0 p-0 column is-11 is-offset-1"><Navigation /></div>
            </div>
            
            {/* Content */}
            <div className='pb-6 columns is-flex is-flex-direction-rows is-justify-content-center main-content'>
              <div className="m-0 p-0 content column is-6">
                <h1 className='pt-4 px-0 pb-0 m-0'>Timezone updated</h1>
                <h2 className='py-2 px-0 m-0'>
                {userEmail ? (
                  <>
                    Your account at <span className='is-bold'>{userEmail}</span> has been updated with your new timezone: <span className='is-bold'>{userTimezone}</span>.
                    <br /><br />
                    All of your future reminders will now be delivered according to this timezone. Need help with anything else? Visit the <a href="/how-to" className="textLink">How to guide</a> or the <a href="/contact" className="textLink">Contact</a> page.
                  </>
                ) : (
                  <>
                    Your timezone has been successfully updated. All of your future reminders will now be delivered according to your new timezone setting.
                    <br /><br />
                    Need help with anything else? Visit the <a href="/how-to" className="textLink">How to guide</a> or the <a href="/contact" className="textLink">Contact</a> page.
                  </>
                )}
                </h2>
              </div>
            </div>
          </div>
          
          {/* Footer */}
          <div className='footer m-0 p-0 columns is-flex is-flex-direction-rows is-justify-content-center is-align-items-center'>
            <div className="m-0 p-0 column is-11 is-10-mobile"><Footer /></div>
          </div>
        </div>
      </section>
  );
}

export default TimezoneSuccess;